import styled from "@emotion/styled";
import { Checkbox } from "@mui/material";

export const CheckBoxStyled = styled(Checkbox)`
  font-weight: 400;
  padding: 0;
  margin-right: 12px;
  border-radius: 7px;

  &:hover:not(.Mui-checked) {
    & svg {
      rect {
        fill: ${({ variant, theme }) =>
          variant === "dark"
            ? theme.colors.secondary.gray
            : theme.colors.secondary.stroke};
        stroke: ${({ variant, theme }) =>
          variant === "dark"
            ? theme.colors.secondary.minor
            : theme.colors.secondary.stroke};
      }
    }
  }

  & .MuiCheckbox-input {
    ${({ variant, theme }) =>
      variant === "dark" &&
      `
      color: ${theme.colors.secondary.main};
    `}

    ${({ variant, theme }) =>
      variant === "gray" &&
      `
      color: ${theme.colors.secondary.main};
    `}
  }

  & + span {
    ${({ variant, theme }) =>
      variant === "dark" &&
      `
      color: ${theme.colors.white};
    `}

    ${({ variant, theme }) =>
      variant === "gray" &&
      `
      color: ${theme.colors.black};
    `}
  }
`;
